import { Component, ElementRef, HostListener, OnInit } from '@angular/core';
import { RouterLink, Router, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs/operators';
import { environment } from '../../../environments/environment';
import { TranslateModule } from '@ngx-translate/core';
import { CommunicateService } from '../../core/services/communicate.service';

@Component({
  selector: 'app-user-footer',
  standalone: true,
  imports: [RouterLink, TranslateModule],
  templateUrl: './user-footer.component.html',
  styleUrl: './user-footer.component.css'
})
export class UserFooterComponent implements OnInit {
     
  essentialMode = false;
  isUserDropdownOpen = false;

  userProfile: any = [];

  constructor(
    private router: Router,
    private elementRef: ElementRef,
    private communicate: CommunicateService
  ) {}

  ngOnInit() {
    this.loadUserProfile();
  }



  private loadUserProfile() {
    const userName = localStorage.getItem('userName') || '';
    let userEmail = localStorage.getItem('userEmail') || localStorage.getItem('email') || '';
    if (!userEmail) {
      try {
        const spUser = JSON.parse(localStorage.getItem('sp-user') || '{}');
        userEmail = spUser?.userEmail || spUser?.email || spUser?.recipientEmail || '';
      } catch {
        userEmail = '';
      }
    }

    this.userProfile.name = userName;
    this.userProfile.email = userEmail;
    this.userProfile.avatarUrl = `https://ui-avatars.com/api/?name=${encodeURIComponent(userName)}&background=4f46e5&color=fff`;
  }

  toggleUserDropdown(event?: Event) {
    event?.stopPropagation();
    this.isUserDropdownOpen = !this.isUserDropdownOpen;
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent) {
    const clickedInside = this.elementRef.nativeElement.contains(event.target as Node);
    if (!clickedInside) {
      this.isUserDropdownOpen = false;
    }
  }


  onMenuAction(action?: 'keyboard-shortcuts' | 'sign-out') {

    if (action === 'keyboard-shortcuts') {
      this.communicate.openShortcutsModal();
      document.body.style.overflow = 'hidden';
      this.isUserDropdownOpen = false;
      return;
    }

    if (action === 'sign-out') {
      localStorage.clear();
      const senderTabId = this.getTabId();
      localStorage.setItem(
        'GLOBAL_LOGOUT',
        JSON.stringify({
          senderTabId,
          time: Date.now()
        })
      );
      window.location.href = `${environment.blazzerUrl}/account/logout`;
    }
  }

  private getTabId(): string {
    let tabId = sessionStorage.getItem('TAB_ID');
    if (!tabId) {
      tabId = crypto.randomUUID();
      sessionStorage.setItem('TAB_ID', tabId);
    }
    return tabId;
  }

 
  
}